import React, { useEffect } from 'react';
import { XIcon } from './icons';

// Controlled modal replacing the old admin's jQuery/Bootstrap modals
// (window.$("#id").modal("show")). Bottom sheet on mobile, centered card on
// desktop — same pattern as fact-find-test/Shell.js renderLeaveModal.
const SIZES = {
    sm: 'sm:max-w-sm',
    md: 'sm:max-w-lg',
    lg: 'sm:max-w-2xl',
    xl: 'sm:max-w-4xl',
};

export const ModalBody = ({ children, className = '' }) => (
    <div className={`px-5 sm:px-6 py-5 overflow-y-auto ${className}`}>{children}</div>
);

export const ModalFooter = ({ children }) => (
    <div className="px-5 sm:px-6 py-4 border-t border-[#E5E7EB] flex flex-col-reverse sm:flex-row gap-2 sm:justify-end rounded-b-2xl bg-white">
        {children}
    </div>
);

const Modal = ({ open, onClose, title, subtitle, size = 'md', children }) => {
    useEffect(() => {
        if (!open) return undefined;
        const onKey = (e) => {
            if (e.key === 'Escape') onClose();
        };
        document.addEventListener('keydown', onKey);
        const prevOverflow = document.body.style.overflow;
        document.body.style.overflow = 'hidden';
        return () => {
            document.removeEventListener('keydown', onKey);
            document.body.style.overflow = prevOverflow;
        };
    }, [open, onClose]);

    if (!open) return null;

    return (
        <div
            className="fixed inset-0 z-50 flex items-end sm:items-center justify-center p-0 sm:p-6"
            style={{ backgroundColor: 'rgba(15, 17, 26, 0.55)', backdropFilter: 'blur(2px)' }}
            role="dialog"
            aria-modal="true"
            onClick={(e) => {
                if (e.target === e.currentTarget) onClose();
            }}
        >
            <div
                className={`w-full ${SIZES[size] || SIZES.md} bg-white rounded-t-2xl sm:rounded-2xl shadow-xl border border-[#E5E7EB] flex flex-col max-h-[92vh] sm:max-h-[85vh]`}
            >
                <div className="px-5 sm:px-6 py-4 border-b border-[#E5E7EB] flex items-start justify-between gap-4 flex-shrink-0">
                    <div className="min-w-0">
                        <h2 className="text-lg font-bold text-[#1F2937]">{title}</h2>
                        {subtitle ? <p className="mt-0.5 text-sm text-[#6B7280]">{subtitle}</p> : null}
                    </div>
                    <button
                        type="button"
                        onClick={onClose}
                        aria-label="Close"
                        className="rounded-lg p-1.5 text-[#6B7280] hover:bg-[#F5F6FA] hover:text-[#1F2937] transition-colors flex-shrink-0"
                    >
                        <XIcon className="h-5 w-5" />
                    </button>
                </div>
                <div className="flex-1 min-h-0 flex flex-col overflow-hidden">{children}</div>
            </div>
        </div>
    );
};

export default Modal;
